"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var service_service_1 = require("src/app/Services/service.service");
var moment = require("moment");
var WickedApiClient_1 = require("../../api/WickedApiClient");
var advertisement_service_1 = require("./../../../Services/advertisement.service");
var adv_user_advertisements_component_1 = require("src/app/Adveristments/adv-user-advertisements/adv-user-advertisements.component");
var UserAdvertisementsComponent = /** @class */ (function (_super) {
    __extends(UserAdvertisementsComponent, _super);
    function UserAdvertisementsComponent(route, service) {
        var _this = _super.call(this, route, service) || this;
        _this.route = route;
        _this.service = service;
        _this.enableSubscription = false;
        _this.enableSubscription = service.enableSubscription;
        service.pageName = "My Ads";
        return _this;
    }
    UserAdvertisementsComponent.prototype.ngOnInit = function () {
        if (!this.service.userService.isDemo()) {
            this.viewMode = advertisement_service_1.ViewMode.ACTIVE;
        }
        this.performSearch();
    };
    UserAdvertisementsComponent.prototype.performSearch = function () {
        this.currentUserId = this.service.userService.getUserId();
        this.service.advService.searchDataUserAdv.currentSearchRule.userId = this.currentUserId;
        this.service.advService.searchActionForUser(this.viewMode);
    };
    UserAdvertisementsComponent.prototype.getDate = function (card) {
        return card.dateStart.format("MM/DD/YYYY hh:mm A");
    };
    Object.defineProperty(UserAdvertisementsComponent.prototype, "length", {
        get: function () {
            return this.service.advService.searchDataUserAdv.resultCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserAdvertisementsComponent.prototype, "pageSize", {
        get: function () {
            return this.service.advService.searchDataUserAdv.currentSearchRule.pageSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserAdvertisementsComponent.prototype, "pageNumber", {
        get: function () {
            return this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber;
        },
        enumerable: true,
        configurable: true
    });
    UserAdvertisementsComponent.prototype.getAdvTitle = function (adv) {
        var tag = this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId ? "" : "[" + adv.categoryCode + "] ";
        return "" + tag + adv.title;
    };
    UserAdvertisementsComponent.prototype.advIsExpired = function (adv) {
        return adv.dateStart.isSameOrBefore(moment().subtract(14, 'day'));
    };
    UserAdvertisementsComponent.prototype.getLocation = function (adv) {
        return adv.subRegionName + ", " + adv.regionShortName;
    };
    UserAdvertisementsComponent.prototype.hasAdvertismentImage = function (advertisment) {
        return advertisment.images.length > 0;
    };
    UserAdvertisementsComponent.prototype.showTip = function (e) {
        e.stopPropagation();
        e.target.getElementsByClassName("textTip")[0].style.opacity = "1";
        setTimeout(function () {
            e.target.getElementsByClassName("textTip")[0].style.opacity = "0";
        }, 2000);
    };
    return UserAdvertisementsComponent;
}(adv_user_advertisements_component_1.AdvUserAdvertisementsComponent));
exports.UserAdvertisementsComponent = UserAdvertisementsComponent;
